import PartnerModel from '../DataModels/Partner';
import { actionManager } from './BaseFunction';
// ///////////////
// Reducers
// ///////////////
const partnerDM = new PartnerModel();
const Partners = (state = partnerDM, action) => actionManager(state, action, 'partners');

export default Partners;
